import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 实时数据
 **********************************************************************************/
export default {
	/**
	 * 开启打印
	 */
	getCameraTree: (success, failure) => {
		Axios.post('/camera/getCameraTree.do', {}, success, failure);
	},
}
